import { render, staticRenderFns } from "./Profile.modal.vue?vue&type=template&id=6b03226e"
import script from "./Profile.modal.vue?vue&type=script&lang=js"
export * from "./Profile.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports